module.exports = __webpack_public_path__ + "img/company.7c727b3b.png";